export const SET_WHITEBOARD_SIZE = 'SET_WHITEBOARD_SIZE'
export const SET_WHITEBOARD_URL = 'SET_WHITEBOARD_URL'
export const SET_IS_CONNECTED_TO_SECONDARY_DEVICE =
    'SET_IS_CONNECTED_TO_SECONDARY_DEVICE'
export const SET_PREVIOUS_WHITEBOARD = 'SET_PREVIOUS_WHITEBOARD'
